<template>
  <div>
    <div
      class="flex overflow-x-auto scrollbar-none gap-8 mt-4 md:mt-12 mb-16 -mx-24 px-24 py-4 md:px-40 md:mx-0"
    >
      <RevSkeleton
        v-for="num in 4"
        :key="num"
        width="136px"
        height="40px"
        shape="circle"
      />
    </div>

    <div
      class="hidden grid-cols-2 overflow-hidden px-40 pb-40 pt-16 md:grid lg:grid-cols-5 min-[1536px]:grid-cols-6"
    >
      <div
        v-for="(num, index) in 5"
        :key="num"
        class="rounded-full p-16 pt-0"
        :class="{
          'hidden lg:block': index === 4,
          'hidden min-[1536px]:block': index > 4,
        }"
      >
        <RevSkeleton class="mb-8" height="16px" shape="line" width="120px" />
        <div class="flex justify-center p-8">
          <RevSkeleton height="128px" shape="rectangle" width="128px" />
        </div>
        <div class="flex flex-col gap-8 pt-8">
          <RevSkeleton height="20px" shape="line" width="136px" />
          <RevSkeleton height="12px" shape="line" width="44px" />
          <RevSkeleton height="20px" shape="line" width="92px" />
        </div>
      </div>
    </div>

    <div class="flex flex-col md:hidden">
      <div v-for="num in 3" :key="num" class="rounded-sm flex items-center p-8">
        <div class="flex grow items-center gap-8 text-left">
          <RevSkeleton
            class="rounded-sm"
            height="24px"
            shape="line"
            width="24px"
          />

          <div class="flex grow flex-col">
            <span class="py-2">
              <RevSkeleton height="20px" shape="line" width="136px" />
            </span>
            <span class="py-2">
              <RevSkeleton height="12px" shape="line" width="44px" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
